/**
 * @generated SignedSource<<ae494c5fc69511279734c598f42b735e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "callbackQuery",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamCallbackGraphiqlQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TeamCallbackGraphiqlQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "27560d0a8754458601ecb6c78e610d3c",
    "id": null,
    "metadata": {},
    "name": "TeamCallbackGraphiqlQuery",
    "operationKind": "query",
    "text": "query TeamCallbackGraphiqlQuery {\n  viewer {\n    id\n    team {\n      id\n      callbackQuery\n    }\n  }\n}\n"
  }
};
})();

node.hash = "110a6c5c76697fb39718ef8066d08d79";

export default node;
